import { authHttpInstance } from './httpClient';

/**
 * Authorization service to validate user SSO ID
 * @param {string} ssoId - User's SSO ID
 * @return {Promise<Object>} Authorization response data
 * @throws {Error} If validation fails
 */
export const authorizationService = async ({ ssoId, email }) => {
  try {
    const payload = {};
    if (ssoId) payload.ssoId = ssoId;
    if (email) payload.email = email;

    const response = await authHttpInstance.post(
      import.meta.env.VITE_AUTH_ENDPOINT,
      payload,
    );

    if (response.status !== 200) {
      throw new Error('Failed to validate user');
    }

    return response.data;
  } catch (error) {
    console.error('Error validating user:', error);
    throw error;
  }
};
